/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** MailResponse */
export interface MailResponse {
  emailId: number;
  subject: string;
  /** @format date-time */
  timestamp: string;
  from: string;
  hasAttachments: boolean;
  status: MailStatus;
}

/** GetMailsResponse */
export interface GetMailsResponse {
  pageIndex: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: MailResponse[];
}

/** Attachment */
export interface Attachment {
  content: string;
  type: string;
  fileName: string;
  disposition: string;
  contentId: string;
}

/** Email */
export interface Email {
  name: string;
  email: string;
}

/** MailDetailResponse */
export interface MailDetailResponse {
  emailId: number;
  parentEmailId: number;
  fromAddress: Email;
  toList: Email[];
  ccList: Email[];
  bccList: Email[];
  attachments: Attachment[];
  subject: string;
  content: string;
  /** @format date-time */
  timestamp: string;
  application: string;
  status: MailStatus;
}

/** ResendMailValues */
export interface ResendMailValues {
  emailId: number;
  to: Email[];
  cc?: Email[];
  bcc?: Email[];
  application?: string;
}

/** MailStatus */
export type MailStatus = 'sent' | 'pending';

export interface GetMailsParams {
  pageSize?: number;
  pageIndex?: number;
  search?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios';

type HeaderValue = string | string[] | number | boolean | null;

interface RawHeaders {
  [key: string]: HeaderValue;
}

interface HeadersDefaults {
  common: RawHeaders;
  delete: RawHeaders;
  get: RawHeaders;
  head: RawHeaders;
  post: RawHeaders;
  put: RawHeaders;
  patch: RawHeaders;
  options?: RawHeaders;
  purge?: RawHeaders;
  link?: RawHeaders;
  unlink?: RawHeaders;
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || 'http://localhost:3000' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data?.response);
  };
}

/**
 * @title MailsModule
 * @version 1.0
 * @baseUrl http://localhost:3000
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name GetMails
     * @summary Your GET endpoint
     * @request GET:/api/mail/v2/mails
     */
    getMails: (query: GetMailsParams, params: RequestParams = {}) =>
      this.request<GetMailsResponse, any>({
        path: `/api/mail/v2/mails`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetMailDetail
     * @summary Your GET endpoint
     * @request GET:/api/mail/v2/mails/{id}
     */
    getMailDetail: (id: number, params: RequestParams = {}) =>
      this.request<MailDetailResponse, any>({
        path: `/api/mail/v2/mails/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ResendMail
     * @request POST:/api/mail/v2/mails/resend
     */
    resendMail: (data: ResendMailValues, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/mail/v2/mails/resend`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ResendPendingMails
     * @request POST:/api/mail/v2/mails/resendpending
     */
    resendPendingMails: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/mail/v2/mails/resendpending`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPendingMailsCount
     * @summary Your GET endpoint
     * @request GET:/api/mail/v2/mails/pending/count
     */
    getPendingMailsCount: (params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/api/mail/v2/mails/pending/count`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
